var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
import { Label } from "./Label";
var block = bem("rmd-floating-label");
/**
 * This is an extension of the `Label` component that is used with text fields
 * and textareas to float above the input area.
 */
export var FloatingLabel = forwardRef(function FloatingLabel(_a, ref) {
    var className = _a.className, dense = _a.dense, valued = _a.valued, floating = _a.floating, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, props = __rest(_a, ["className", "dense", "valued", "floating", "error", "active", "disabled"]);
    return (React.createElement(Label, __assign({}, props, { ref: ref, className: cn(block({
            dense: dense,
            active: floating,
            inactive: valued && !active && !error && !disabled,
        }), className), error: error, active: active, disabled: disabled })));
});
/* istanbul ignore next */
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        FloatingLabel.propTypes = {
            className: PropTypes.string,
            dense: PropTypes.bool,
            floating: PropTypes.bool,
            error: PropTypes.bool,
            active: PropTypes.bool,
            disabled: PropTypes.bool,
            valued: PropTypes.bool.isRequired,
        };
    }
    catch (e) { }
}
//# sourceMappingURL=FloatingLabel.js.map